/**
 * Anulación manual de una tarea del ERP (DEVS-4204, solo Administrador): se
 * cierra en Plataforma la gestión colaborativa de un remito que no se traza en
 * RigaTraza. El remito sigue vigente, así que sus unidades egresan.
 */

import { z } from 'zod';

/** GET /api/despacho/tareas/:erpId?glnId=N — datos para confirmar antes de anular. */
export const TareaParaAnularSchema = z.object({
  erpId: z.string(),
  referencia: z.string().nullable(),
  numeroRemito: z.string().nullable(),
  entidad: z.string().nullable(),
  fechaCreacion: z.string().nullable(),
  estado: z.string(),
  /** Ya cerrada en Plataforma: anular solo completa lo local. */
  cerradaEnErp: z.boolean(),
  /** Unidades del remito que van a egresar. */
  unidades: z.object({
    reservadas: z.number(),
    pickeadas: z.number(),
  }),
  /** Motivo por el que no se puede anular; null si se puede. */
  bloqueo: z.object({ code: z.string(), message: z.string() }).nullable(),
});
export type TareaParaAnular = z.infer<typeof TareaParaAnularSchema>;

/** POST /api/despacho/tareas/:erpId/anular */
export const AnularTareaResponse = z.object({
  erpId: z.string(),
  referencia: z.string().nullable(),
  egresadas: z.number(),
  /** `informado`: se cerró en Plataforma ahora; `ya_cerrada`: ya estaba cerrada. */
  cierreErp: z.enum(['informado', 'ya_cerrada']),
});
export type AnularTareaResult = z.infer<typeof AnularTareaResponse>;
